import React, {useRef, useState} from "react";
import LeftMenu from "../../../components/LeftMenu/LeftMenu";
import {
    ADMIN_ENROLLMENTS_ROUTE,
    ADMIN_REGISTRATE_USER,
    CHAT_PAGE_ROUTE,
    CHAT_USERS_PAGE_ROUTE
} from "../../../shared/utils/consts";
import { useNavigate, Link } from "react-router-dom";

import { useAdminListeners } from "../../../hooks/useAdminListeners";
import UserTable from "./components/UserTable";
import Pagination from "./components/Pagination";
import SearchAndSortPanel from "./components/SearchAndSortPanel";
import Button from "../../../shared/ui/buttons/Button";
import AdminPath from "../../../components/ui/AdminPath";
import AppContainer from "../../../components/ui/AppContainer";
import SearchInput from "../../../shared/ui/inputs/SearchInput";
import {useModals} from "../../../hooks/useModals";
import {createChat} from "../../../entities/chat/api/chat.api";

interface ContextMenuState {
    visible: boolean;
    x: number;
    y: number;
    userId: number | null;
    programId: number | null;
}

const AdminListeners: React.FC = () => {
    const navigate = useNavigate();
    const {
        users, filteredUsers, loading, countUsers,
        searchInput,
        handleSearchInput,
        handleClickPagination, destroyUser, activePage
    } = useAdminListeners();

    const {openModal} = useModals();
    
    const [contextMenu, setContextMenu] = useState<ContextMenuState>({
        visible: false,
        x: 0,
        y: 0,
        userId: null,
        programId: null
    });


    const handleEdit = (id: number) => navigate(`/admin/listeners/new_listener/${id}`);
    const containerRef = useRef<HTMLDivElement>(null);
    const handleContextMenu = (e: React.MouseEvent, userId: number, programId: number) => {
        e.preventDefault(); // отключаем стандартное меню
        const rect = containerRef.current.getBoundingClientRect();
        setContextMenu({
            visible: true,
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
            userId,
            programId
        });
    };

    const handleClickOutside = () => {
        if (contextMenu.visible) {
            setContextMenu({ visible: false, x: 0, y: 0, userId: null, programId: null });
        }
    };

    const handleDestroyUser = async(userId: number) => {
        const confirmed = await openModal('confirm', {
            title: 'Вы действительно хотите удалить пользователя?',
            description: 'Отменить действие будет невозможно',
            confirmText: 'Удалить',
            variant: "danger",
        })
        if (!confirmed) return;

        await destroyUser(userId)
    }

    return (
        <AppContainer onClick={handleClickOutside}>
            <div className="relative" ref={containerRef}>
                <Button
                    to={ADMIN_REGISTRATE_USER}
                    checkRole="ADMIN"
                >
                    Добавить слушателя
                </Button>

                <SearchInput
                    className="mt-7"
                    value={searchInput}
                    onChange={e => handleSearchInput(e)}
                    placeholder="Поиск..."
                />

                <UserTable
                    handleContextMenu={handleContextMenu}
                    users={filteredUsers}
                    loading={loading}
                    onEdit={handleEdit}
                    onDelete={destroyUser}
                />

                <Pagination
                    pages={countUsers}
                    onClick={handleClickPagination}
                    activePage={activePage}
                />
                {contextMenu.visible && (
                    <div
                        style={{
                            position: "absolute",
                            top: contextMenu.y + "px",
                            left: contextMenu.x + "px",
                        }}
                        className="bg-white z-50 w-[220px] rounded-md overflow-hidden"
                    >
                        <button
                            onClick={() => {
                                if (contextMenu.userId) navigate(ADMIN_ENROLLMENTS_ROUTE.replace(':userId', `${contextMenu.userId}`));
                                setContextMenu({visible: false, x: 0, y: 0, userId: null, programId: null});
                            }}
                            className="w-full bg-[#D9D9D9] hover:bg-[#2D91CB] hover:text-white py-2 px-3 transition text-left text-sm"
                        >
                            Управление доступом
                        </button>
                        <button
                            onClick={() => {
                                async function createChatAsync(userId) {
                                    const chat = await createChat(userId)
                                    navigate(CHAT_USERS_PAGE_ROUTE + `?chatId=${chat.id}`)

                                }

                                if (contextMenu.userId) {
                                    createChatAsync(contextMenu.userId)
                                }
                                setContextMenu({visible: false, x: 0, y: 0, userId: null, programId: null});
                            }}
                            className="w-full bg-[#D9D9D9] hover:bg-[#2D91CB] hover:text-white py-2 px-3 transition text-left text-sm"
                        >
                            Написать слушателю
                        </button>
                        <button
                            onClick={() => {
                                if (contextMenu.userId) navigate(`/admin/listeners/${contextMenu.userId}`);
                                setContextMenu({visible: false, x: 0, y: 0, userId: null, programId: null});
                            }}
                            className="w-full bg-[#D9D9D9] hover:bg-[#2D91CB] hover:text-white py-2 px-3 transition text-left text-sm"
                        >
                            Перейти к слушателю
                        </button>
                        <button
                            onClick={() => {
                                if (contextMenu.userId) navigate(`/admin/programs/${contextMenu.programId}`);
                                setContextMenu({visible: false, x: 0, y: 0, userId: null, programId: null});
                            }}
                            className="w-full bg-[#D9D9D9] hover:bg-[#2D91CB] hover:text-white py-2 px-3 transition text-left text-sm"
                        >
                            Перейти к программе
                        </button>
                        <button
                            onClick={() => {
                                if (contextMenu.userId) handleEdit(contextMenu.userId);
                                setContextMenu({visible: false, x: 0, y: 0, userId: null, programId: null});
                            }}
                            className="w-full bg-[#D9D9D9] hover:bg-[#2D91CB] hover:text-white py-2 px-3 transition text-left text-sm"
                        >
                            Изменить
                        </button>
                        <button
                            onClick={() => {
                                if (contextMenu.userId) handleDestroyUser(contextMenu.userId);
                                setContextMenu({visible: false, x: 0, y: 0, userId: null, programId: null});
                            }}

                            className="w-full bg-[#D9D9D9] hover:bg-red-600 hover:text-white py-2 px-3 transition text-left text-sm"
                        >
                            Удалить
                        </button>
                    </div>
                )}
            </div>

        </AppContainer>
    );
};

export default AdminListeners;